/* istanbul ignore next */
/* esignore */
const mockDataLayer = () => {
  if (process.env.NODE_ENV !== 'production' && !window.dataLayer) {
    window.dataLayer = [];
  }
};

const gtmReady = () => {
  return !!(
    window.gtm?.ready ||
    (() => {
      window.gtm = window.gtm || { ready: false };
      window.gtm.ready =
        window.gtm.ready ||
        !!(
          window.dataLayer &&
          window.dataLayer.find((o) => o.event === 'gtm.load')
        );

      return window.gtm.ready;
    })()
  );
};

const dataLayerPush = (data) => {
  gtmReady()
    ? window.dataLayer.push(data)
    : setTimeout(() => {
        dataLayerPush(data);
      }, 1000);
};

export const pushEvent = (eventData) => {
  // set defaults where applicable
  const {
    event = 'uaevent',
    event_name = null,
    ecommerce = 'undefined',
    referral = null,
    article_name = null,
    articleId = null,
    cta_name = null,
    link_url = null,
    module_name = null,
    form_name = null,
    product_info = null,
    step = null,
    store_name = null,
    click_area = null,
    breadcrumb = null,
    product_tab = null,
    filter_type = null,
    filter_value = null,
    event_detail = null,
    question_title = null,
    click_action = null,
    eventCategory = null,
    eventAction = null,
    eventLabel = null,
    service_name = null,
    service_category = null,
  } = eventData;

  // only push defined values to the data layer
  let dataLayerData = Object.assign(
    {},
    event === null ? null : { event },
    event_name === null ? null : { event_name },
    ecommerce === null ? null : { ecommerce },
    referral === null ? null : { referral },
    article_name === null ? null : { article_name },
    articleId === null ? null : { articleId },
    cta_name === null ? null : { cta_name },
    link_url === null ? null : { link_url },
    module_name === null ? null : { module_name },
    form_name === null ? null : { form_name },
    product_info === null ? null : { product_info },
    step === null ? null : { step },
    store_name === null ? null : { store_name },
    click_area === null ? null : { click_area },
    breadcrumb === null ? null : { breadcrumb },
    product_tab === null ? null : { product_tab },
    filter_type === null ? null : { filter_type },
    filter_value === null ? null : { filter_value },
    event_detail === null ? null : { event_detail },
    question_title === null ? null : { question_title },
    click_action === null ? null : { click_action },
    eventCategory === null ? null : { eventCategory },
    eventAction === null ? null : { eventAction },
    eventLabel === null ? null : { eventLabel },
    service_name === null ? null : { service_name },
    service_category === null ? null : { service_category }
  );
  mockDataLayer();

  //Verification of full URL
  if (
    typeof dataLayerData.link_url === 'string' &&
    dataLayerData.link_url[0] === '/'
  ) {
    dataLayerData.link_url = `${window.location.origin}${dataLayerData.link_url}`;
  }

  dataLayerPush(dataLayerData);
};

export const pushData = (data) => {
  mockDataLayer();

  if (window.dataLayer && typeof data === 'object' && data !== null) {
    if (typeof data.link_url === 'string' && data.link_url[0] === '/') {
      data.link_url = `${window.location.origin}${data.link_url}`;
    }

    dataLayerPush(data);
  }
};
